import { Layout as AntdLayout } from 'antd'
import type { LayoutProps as AntdLayoutProps } from 'antd'

import { Content } from './Content'
import { Footer } from './Footer'
import { Header } from './Header'
import { Sider } from './Sider'

type LayoutProps = AntdLayoutProps

export function Layout(props: LayoutProps) {
  return <AntdLayout {...props} />
}

Layout.Content = Content
Layout.Footer = Footer
Layout.Header = Header
Layout.Sider = Sider
